import { Component } from '@angular/core';
import { NavController, NavParams, ModalController, Events } from 'ionic-angular';
import { HttpClient } from '../../../services/HttpClient';

import { OfferPage } from './offer/offer';
import { AddOfferPage } from './addOffer/addOffer';

@Component({
  selector: 'page-offers',
  templateUrl: 'offers.html',
  providers : [HttpClient]
})
export class OffersPage {

	offers;
  searchQuery = '';

  modalCtrl : ModalController;
	
  httpClient : HttpClient;

  events : Events;

  	constructor(public navCtrl: NavController, public navParams: NavParams, httpClient : HttpClient,modalCtrl : ModalController, events : Events) {
  		this.modalCtrl = modalCtrl;
      this.httpClient = httpClient;
      this.events = events;
      this.events.subscribe('addOffer:done',()=>{
        this.httpCallOffers('',1000);
      });
      this.events.subscribe('offer:update',()=>{
        this.httpCallOffers('',1000);
      });
      this.events.subscribe('offer:delete',()=>{
        this.httpCallOffers('',1000);
      });
      this.httpCallOffers('',1000);
  	}

    onSearch(){
      if(this.searchQuery.length > 0){
        this.httpCallOffers(this.searchQuery,50);
      }else{
        this.httpCallOffers(this.searchQuery,1000);
      }
    }

    httpCallOffers(name,max){
      this.httpClient.get('/offers?name='+name+'&max='+max,(error,data)=>{
        this.offers = data.json();
      });
    }

    onClickAdd(){
      this.navCtrl.push(AddOfferPage);
    }

    onClickProject(offer){
      this.navCtrl.push(OfferPage,{id : offer.id});
    }
}



// WEBPACK FOOTER //
// ./src/pages/dashboard/offers/offers.ts